<!--
    校区管理-校区列表-查看变更记录
    作用：展示校区年服务变更记录
    组件：el-dialog
-->
<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    title="查看变更记录"
    width="800px"
  >
    <div class="dialog-content">
      <div class="top">
        <span class="block">校区名称：{{ item.review_used.name }}</span>
        <span class="block">校区代码：{{ item.school_code }}</span>
        <span class="block">校区注册时间：{{ item.created_at }}</span>
      </div>
      <AppList
        :list.sync="list"
        :exit-url="false"
        :is-loading="loading"
        :api="`/api/service/operate/clients/${item.id}/vip_logs`"
        title=""
      >
        <template slot-scope="props">
          <el-table :data="props.listData">
            <el-table-column
              width="170"
              label="原服务时间"
            >
              <template slot-scope="{row}">
                {{ row.old_vip_start_at }}~{{ row.old_vip_end_at }}
              </template>
            </el-table-column>
            <el-table-column
              width="170"
              label="变更后服务时间"
            >
              <template slot-scope="{row}">
                {{ row.vip_start_at }}~{{ row.vip_end_at }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="110"
              label="操作账号">
              <template slot-scope="{row}">
                {{ row.admin_user.mobile }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="110"
              label="操作时间"
              prop="created_at"
            />
          </el-table>
        </template>
      </AppList>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'SeeChangeLog',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      list: {},
    };
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
    submitData() {
      this.$emit('close-dialog');
      this.$emit('submit-data');
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-content{
  /deep/ .app-list .list-header{
    display: none;
  }
  .top{
    padding: 0 10px;
    margin-bottom: 20px;
    .block{
      display: inline-block;
      margin-right: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/list/dialog/seeChangeLog.vue